import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/msalConfig";
import { Navigate, useNavigate } from "react-router-dom";

const Login = () => {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();

  // If already logged in, check if admin and redirect
  if (accounts.length > 0) {
    const userRoles = accounts[0]?.idTokenClaims?.roles || [];
    const isAdmin = userRoles.includes("Admin");

    if (isAdmin) {
      return <Navigate to="/admin" />;
    }
    return <Navigate to="/" />;
  }

  const handleLogin = async () => {
    try {
      const response = await instance.loginPopup(loginRequest);

      // Check if user has admin role after login
      const userRoles = response.account?.idTokenClaims?.roles || [];
      const isAdmin = userRoles.includes("Admin");

      if (isAdmin) {
        navigate("/admin");
      } else {
        navigate("/");
      }
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Sign in to your account
          </h2>
        </div>
        <div>
          <button
            onClick={handleLogin}
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Sign in with Microsoft
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
